<template>
  <div>
    <div
      class="accordion"
      v-for="(accordionItem, index) in accordionData"
      :key="uniquePrefix+index"
      @click="itemClicked(uniquePrefix+index)"
    >
      <AccordionItem
        :item="accordionItem"
        :itemId="uniquePrefix+index"
        :active="activeItemKey === uniquePrefix+index"
      />
    </div>
  </div>
</template>

<script>
import { TweenLite } from "gsap/dist/gsap";
import AccordionItem from "@/components/sections/Seating/AccordionItem";
export default {
  name: "Accordion",
  components: {
    AccordionItem
  },
  data() {
    return {
      activeItemKey: ""
    };
  },
  props: {
    accordionData: {
      type: Array,
      required: true
    },
    uniquePrefix:{
      type: String,
      required: false,
      default: 'seatingFaq'
    }
  },
  methods: {
    itemClicked(itemId) {
      let currentActiveEle = document.getElementById(this.activeItemKey);
      let activeItemKeyCopy = this.activeItemKey;
      if (currentActiveEle) {
        this.activeItemKey = "";
        TweenLite.to(currentActiveEle, 0.5, {
          height: 0
        });
      }
      if (itemId != activeItemKeyCopy) {
        this.activeItemKey = itemId;
        let newActiveEle = document.getElementById(itemId);
        TweenLite.to(newActiveEle, 0.5, {
          height: newActiveEle.scrollHeight
        });
      }
    }
  }
};
</script>

<style lang="scss">
.accordion {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  .how-renew-desc {
    text-align: center;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    margin-bottom: 22px;
    width: 100%;
    b {
      color: #f00;
    }
  }
}
</style>